import { render } from "./DiagnosticHypothesisSection.vue?vue&type=template&id=5786d8f0"
import script from "./DiagnosticHypothesisSection.vue?vue&type=script&lang=js"
export * from "./DiagnosticHypothesisSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__